module.exports = {
      id: "follow-youtube-usage",
      viewBox: "0 0 28 29",
      url: __webpack_public_path__ + "svg-sprite.svg#follow-youtube",
      toString: function () {
        return this.url;
      }
    }